import { AiFillEdit } from "react-icons/ai";
import { useAppContext } from "../../context/appContext";
import Wrapper from "../../assets/wrappers/Location";
import PermissionGuard from "../PermissionGuard";

const ItemCategory = ({ itemCategory }) => {
  const { setEditItemCategory } = useAppContext();

  return (
    <Wrapper>
      <div className="item-location">
        <b>{itemCategory.categoryName}</b>
        <PermissionGuard permission="editItemCategories">
          {itemCategory.categoryName !== "Default" && (
            <button
              className="item-location-button"
              onClick={() => setEditItemCategory(itemCategory._id)}
            >
              <AiFillEdit />
            </button>
          )}
        </PermissionGuard>
      </div>
    </Wrapper>
  );
};

export default ItemCategory;
